import { SVGProps } from 'react';

export const StarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5 0L6.12257 3.45492H9.75528L6.81636 5.59017L7.93893 9.04508L5 6.90983L2.06107 9.04508L3.18364 5.59017L0.244718 3.45492H3.87743L5 0Z" />
    </svg>
  );
};
